import { KeyValue } from '@angular/common';

export enum ResidentialStatus {
  HostedByAThird = 'HostedByAThird',
  HostedByParents = 'HostedByParents',
  HostedByFamily = 'HostedByFamily',
  HostedByOther = 'HostedByOther',
  HostedInFosterCare = 'HostedInFosterCare',
  Tenant = 'Tenant',
  Owner = 'Owner',
  Homeless = 'Homeless',
}

export enum ResidentialStatusLabel {
  HostedByAThird = 'Hébergé chez un tiers',
  HostedByParents = 'Hébergé chez un tiers - Père/Mère',
  HostedByFamily = 'Hébergé chez un tiers - Famille',
  HostedByOther = 'Hébergé chez un tiers - Autre',
  HostedInFosterCare = 'Hébergé en foyer',
  Tenant = 'Locataire',
  Owner = 'Propriétaire',
  Homeless = 'Sans domicile fixe',
}

export const labelsByResidentialStatus: KeyValue<ResidentialStatus, string>[] = Object.keys(ResidentialStatus).map((x: ResidentialStatus) => {
  return { key: x, value: ResidentialStatusLabel[x] };
});
